import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../../../../src/app/Services/api.service';
import { CommonServices } from '../../../../../../../src/app/Services/common.service';
import { MapService } from '../../../../../../../src/app/Services/map.service';
import { StorageService } from '../../../../../../../src/app/Services/storage.service';

declare const am4charts: any, am4core: any, am4themes_animated: any;


@Component({
  selector: 'app-route-info',
  templateUrl: './route-info.component.html',
  styleUrls: ['./route-info.component.css']
})
export class RouteInfoComponent implements OnInit {

  public orgID;
  public routeInfoData = {};
  public routeSummary: any = {};
  selectedSlotIndex = 'pickup';

  public formObject = {
    hours: '24',
    routeType: 'all',
    transitMode: 'pickupDrop'
  };

  public totalTrip;
  public assignedTrip;
  public acceptedTrip;
  public runningTrip;

  public regularPickup;

  public assignedTripLabel:any = [];
  public acceptedTripLabel:any = [];
  public runningTripLabel:any = [];
  public malePassengerLabel:any = [];
  public femalePassengerLabel:any = [];

  public assignedTripValue:any = [];
  public acceptedTripValue:any = [];
  public runningTripValue:any = [];
  public malePassengerValue:any = [];
  public femalePassengerValue:any = [];

  public ppFromDate: any;
  public ppToDate: any;
  public currentDate = new Date();
  public defaultDate = this.comservice.timestampToDate(this.currentDate, 'YMD', '-');
  public fromDateErr: string = '';
  public toDateErr: string = '';
  public invalidErr: string = '';
  public dateFormSubmitted: boolean = false;
  public completedPPcount: any;
  public balancePPcount: any;
  public totalPPcount: any;
  public completedPPwidth: any = 0;
  public balancePPcontent: string = 'Yet to complete';
  public showChart: boolean = true;
  public data:any = {
    "pickUpPointCount": {
      "regular": {
        "pickup": {
          "total": 0,
          "completed": 0,
          "pending": 0,
          "intransit": 0,
        },
        "drop": {
          "total": 0,
          "completed": 0,
          "pending": 0,
          "intransit": 0,
        }
      },
      "openBooking": {
        "drop": {
          "total": 0,
          "completed": 0,
          "pending": 0,
          "intransit": 0
        },
        "pickup": {
          "total": 0,
          "completed": 0,
          "pending": 0,
          "intransit": 0
        },
      },
      "occasional": {
        "pickup": {
          "total": 0,
          "completed": 0,
          "pending": 0,
          "intransit": 0,
        },
        "drop": {
          "total": 0,
          "completed": 0,
          "pending": 0,
          "intransit": 0,
        }
      }
    },
    "tripCount": {
      "regular": {
        "pickup": {
          "total": 0,
          "completed": 0,
          "yetToStart": 0,
          "intransit": 0
        },
        "drop": {
          "total": 0,
          "completed": 0,
          "yetToStart": 0,
          "intransit": 0
        }
      },
      "openBooking": {
        "pickup": {
          "total": 0,
          "completed": 0,
          "yetToStart": 0,
          "intransit": 0
        },
        "drop": {
          "total": 0,
          "completed": 0,
          "yetToStart": 0,
          "intransit": 0
        }
      },
      "occasional": {
        "pickup": {
          "total": 0,
          "completed": 0,
          "yetToStart": 0,
          "intransit": 0
        },
        "drop": {
          "total": 0,
          "completed": 0,
          "yetToStart": 0,
          "intransit": 0
        }
      }
    }
  }

  // armcahrt
  public armpiedata = {
    // pickup count start
    "pickUpPointCount": {
      "regular": {
        "pickup": [
          {
            labels: "Completed",
            data: this.data.pickUpPointCount.regular.pickup.completed,
            colors: "#4CAF50"
          },
          {
            labels: "Pending",
            data: this.data.pickUpPointCount.regular.pickup.pending,
            colors: "#FF5252"

          },
          {
            labels: "Intransit",
            data: this.data.pickUpPointCount.regular.pickup.intransit,
            colors: "#03A9F4"
          }
        ],
        "drop": [
          {
            labels: "Completed",
            data: this.data.pickUpPointCount.regular.drop.completed
          },
          {
            labels: "Pending",
            data: this.data.pickUpPointCount.regular.drop.pending
          },
          {
            labels: "Intransit",
            data: this.data.pickUpPointCount.regular.drop.intransit
          }
        ],
      },
      "occasional": {

        "pickup": [
          {
            labels: "Completed",
            data: this.data.pickUpPointCount.occasional.pickup.completed
          },
          {
            labels: "Pending",
            data: this.data.pickUpPointCount.occasional.pickup.pending
          },
          {
            labels: "Intransit",
            data: this.data.pickUpPointCount.occasional.pickup.intransit
          }
        ],
        "drop": [
          {
            labels: "Completed",
            data: this.data.pickUpPointCount.occasional.drop.completed
          },
          {
            labels: "Pending",
            data: this.data.pickUpPointCount.occasional.drop.pending
          },
          {
            labels: "Intransit",
            data: this.data.pickUpPointCount.occasional.drop.intransit
          }
        ],

      },
      "openBooking": {

        "pickup": [
          {
            labels: "Completed",
            data: this.data.pickUpPointCount.openBooking.pickup.completed
          },
          {
            labels: "Pending",
            data: this.data.pickUpPointCount.openBooking.pickup.pending
          },
          {
            labels: "Intransit",
            data: this.data.pickUpPointCount.openBooking.pickup.intransit
          }
        ],
        "drop": [
          {
            labels: "Completed",
            data: this.data.pickUpPointCount.openBooking.drop.completed
          },
          {
            labels: "Pending",
            data: this.data.pickUpPointCount.openBooking.drop.pending
          },
          {
            labels: "Intransit",
            data: this.data.pickUpPointCount.openBooking.drop.intransit
          }
        ],

      },

    },
    // pickup count end

    // tripcount start
    "tripCount": {
      "regular": {
        "pickup": [
          {
            labels: "Completed",
            data: this.data.tripCount.regular.pickup.completed
          },
          {
            labels: "yetToStart",
            data: this.data.tripCount.regular.pickup.yetToStart
          },
          {
            labels: "Intransit",
            data: this.data.tripCount.regular.pickup.intransit
          },

        ],
        "drop": [
          {
            labels: "Completed",
            data: this.data.tripCount.regular.drop.completed
          },
          {
            labels: "yetToStart",
            data: this.data.tripCount.regular.drop.yetToStart
          },
          {
            labels: "Intransit",
            data: this.data.tripCount.regular.drop.intransit
          },
        ],
      },
      "occasional": {
        "pickup": [
          {
            labels: "Completed",
            data: this.data.tripCount.regular.pickup.completed
          },
          {
            labels: "yetToStart",
            data: this.data.tripCount.regular.pickup.yetToStart
          },
          {
            labels: "Intransit",
            data: this.data.tripCount.regular.pickup.intransit
          },
        ],
        "drop": [
          {
            labels: "Completed",
            data: this.data.tripCount.regular.drop.completed
          },
          {
            labels: "yetToStart",
            data: this.data.tripCount.regular.drop.yetToStart
          },
          {
            labels: "Intransit",
            data: this.data.tripCount.regular.drop.intransit
          },
        ],
      },
      "openBooking": {
        "pickup": [
          {
            labels: "Completed",
            data: this.data.tripCount.openBooking.pickup.completed
          },
          {
            labels: "yetToStart",
            data: this.data.tripCount.openBooking.pickup.yetToStart
          },
          {
            labels: "Intransit",
            data: this.data.tripCount.openBooking.pickup.intransit
          },
        ],
        "drop": [
          {
            labels: "Completed",
            data: this.data.tripCount.openBooking.drop.completed
          },
          {
            labels: "yetToStart",
            data: this.data.tripCount.openBooking.drop.yetToStart
          },
          {
            labels: "Intransit",
            data: this.data.tripCount.openBooking.drop.intransit
          },
        ],
      }

    },
    // trip count end
  }



  // count total chart data



  chart_pickUpPointCountregularPickuppie: any = {
    labels: ["total"],
    data: [
      this.data.pickUpPointCount.regular.pickup.total,

    ],
    title: '# Regular Pickup'
  }
  chart_pickUpPointCountregularDroppie: any = {
    labels: ["total"], data: [
      this.data.pickUpPointCount.regular.drop.total,]

  }

  chart_pickUpPointCountoccasionalPickuppie: any = {
    labels: ["total"], data: [
      this.data.pickUpPointCount.occasional.pickup.total,]

  }
  chart_pickUpPointCountoccasionalDroppie: any = {
    labels: ["total"], data: [
      this.data.pickUpPointCount.occasional.drop.total,]

  }

  chart_pickUpPointCountopenBookingPickuppie: any = {
    labels: ["total"], data: [
      this.data.pickUpPointCount.openBooking.pickup.total,]

  }
  chart_pickUpPointCountopenBookingDroppie: any = {
    labels: ["total"], data: [
      this.data.pickUpPointCount.openBooking.drop.total,]

  }

  chart_tripCountregularPickuptotal: any = {
    labels: ["total"], data: [
      this.data.tripCount.regular.pickup.total,]

  }
  chart_tripCountregularDroptotal: any = {
    labels: ["total"], data: [
      this.data.tripCount.regular.drop.total,]

  }
  chart_tripCountoccasionalPickuptotal: any = {
    labels: ["total"], data: [
      this.data.tripCount.occasional.pickup.total,]

  }

  chart_tripCountoccasionalDroptotal: any = {
    labels: ["total"], data: [
      this.data.tripCount.occasional.drop.total,]

  }
  chart_tripCountopenBookingPickuptotal: any = {
    labels: ["total"], data: [
      this.data.tripCount.openBooking.pickup.total,]

  }

  chart_tripCountopenBookingDroptotal: any = {
    labels: ["total"], data: [
      this.data.tripCount.openBooking.drop.total,]

  }
  // armpiechart data pickup point count
  chart_pickUpPointCountregularPickup: any = this.armpiedata.pickUpPointCount.regular.pickup;

  chart_pickUpPointCountregularDrop: any = this.armpiedata.pickUpPointCount.regular.drop;

  chart_pickUpPointCountoccasionalPickup: any = this.armpiedata.pickUpPointCount.occasional.pickup;

  chart_pickUpPointCountoccasionalDrop: any = this.armpiedata.pickUpPointCount.occasional.drop;

  chart_pickUpPointCountopenBookingPickup: any = this.armpiedata.pickUpPointCount.openBooking.pickup;

  chart_pickUpPointCountopenBookingDrop: any = this.armpiedata.pickUpPointCount.openBooking.drop;

  // trip count
  chart_tripCountregularPickup: any = this.armpiedata.tripCount.regular.pickup;
  chart_tripCountregularDrop: any = this.armpiedata.tripCount.regular.drop;
  chart_tripCountoccasionalPickup: any = this.armpiedata.tripCount.occasional.pickup;
  chart_tripCountoccasionalDrop: any = this.armpiedata.tripCount.occasional.drop;
  chart_tripCountopenBookingPickup: any = this.armpiedata.tripCount.openBooking.pickup;
  chart_tripCountopenBookingDrop: any = this.armpiedata.tripCount.openBooking.drop;




  constructor(
    public api: ApiService,

    public route: ActivatedRoute,
    public storage: StorageService,
    public router: Router,
    public comservice: CommonServices) {
    this.orgID = this.storage.get('userInfo').orgID;
  }

  ngOnInit(): void {
    this.getRouteInfo();
    this.getSummary();
    this.getRouteSummary();
    this.getPPcounts(this.currentDate, this.currentDate);
  }

  getSummary() {
    const obj = {
      orgID: this.orgID,
      ...this.formObject,
    };
    this.api.transportManagerRouteSummary(obj).then((res: any) => {
      if (res.status == 'success') {
        this.routeSummary = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getRouteSummary() {
    this.api.transportManagerDashboardRouteSummary({}).then((res: any) => {
      if (res.status == 'success') {
        console.log(res);
        if (res.data && res.data.length > 0) {
          this.patchSummaryData(res.data[0])
        }
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  // Get PickupPoints counts
  getPPcounts(fDate, tDate) {
    let fromDate = new Date(fDate);
    let toDate = new Date(tDate);
    this.ppFromDate = new Date(fromDate.setHours(0, 0, 0)).getTime();
    this.ppToDate = new Date(toDate.setHours(23, 59, 59)).getTime();
    this.getPickDropCount();
  }

  getPickDropCount() {
    let currentTimeStamp = new Date(this.currentDate.setHours(0, 0, 0)).getTime();
    if (this.ppFromDate < currentTimeStamp) this.balancePPcontent = 'Not completed';
    else if (this.ppFromDate >= currentTimeStamp) this.balancePPcontent = 'Yet to complete';

    let obj = { fromDate: this.ppFromDate, toDate: this.ppToDate };
    this.api.transportManagerRouteInfoPPcounts(obj).then((res: any) => {
      if (res.status == 'success') {
        this.patchPPcounts(res);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  patchPPcounts(data) {
    this.completedPPcount = data && data.completedPpcnt ? data.completedPpcnt : 0;
    this.totalPPcount = data && data.totPpcnt ? data.totPpcnt : 0;
    this.balancePPcount = this.totalPPcount - this.completedPPcount;
    this.completedPPwidth = this.completedPPcount / this.totalPPcount * 100;
  }

  //  Get Route Information
  getRouteInfo() {
    const obj = {
      orgID: this.orgID,
    };
    this.api.transportManagerRouteInformationSummary(obj).then((res: any) => {
      if (res.status == 'success') {
        this.routeInfoData = res.data;
        this.setTripValue();
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  setTripValue() {
    this.totalTrip = this.routeInfoData['totalTrips'];
    this.assignedTrip = this.routeInfoData['route']['assigned'];
    this.acceptedTrip = this.routeInfoData['route']['accepted'];
    this.runningTrip = this.routeInfoData['route']['running'];

    this.assignedTripLabel[0] = this.assignedTrip + ' / ' + this.totalTrip + ' Trips';
    this.acceptedTripLabel[0] = this.acceptedTrip + ' / ' + this.assignedTrip + ' Trips';
    this.runningTripLabel[0] = this.runningTrip + ' / ' + this.acceptedTrip + ' Trips';

    this.assignedTripValue[0] = String(((this.assignedTrip / this.totalTrip) * 100).toFixed());
    this.acceptedTripValue[0] = String(((this.acceptedTrip / this.assignedTrip) * 100).toFixed());
    this.runningTripValue[0] = String(((this.runningTrip / this.acceptedTrip) * 100).toFixed());

    if (this.routeInfoData['passengers']['male']) {
      Object.entries(this.routeInfoData['passengers']['male']).forEach(([key, value]) => {
        this.malePassengerLabel.push(key[0].toUpperCase() + key.substr(1).toLowerCase());
        this.malePassengerValue.push(value);
      });
    }

    if (this.routeInfoData['passengers']['female']) {
      Object.entries(this.routeInfoData['passengers']['female']).forEach(([key, value]) => {
        this.femalePassengerLabel.push(key[0].toUpperCase() + key.substr(1).toLowerCase());
        this.femalePassengerValue.push(value);
      });
    }
  }
  dateFromAction(obj: any = {}, type) {
    if (type == 'ppFromDate') {
      this.ppFromDate = obj.selectedDates[0];
    }
    if (type == 'ppToDate') {
      this.ppToDate = obj.selectedDates[0];
    }
    if (this.dateFormSubmitted) this.checkDateError();
  }
  checkDateError() {
    let valid = true
    let fromDateTimeStamp = new Date(this.ppFromDate).getTime();
    let toDateTimeStamp = new Date(this.ppToDate).getTime();

    this.fromDateErr = '', this.toDateErr = ''; this.invalidErr = '';
    if (this.ppFromDate == '' || this.ppFromDate == null || this.ppFromDate == undefined) {
      this.fromDateErr = 'Start date is required.';
      valid = false;
    } else if (this.ppToDate == '' || this.ppToDate == null || this.ppToDate == undefined) {
      this.toDateErr = 'End date is required.';
      valid = false;
    } else if (fromDateTimeStamp > toDateTimeStamp) {
      this.invalidErr = 'End date should be less than start date.';
      valid = false;
    }
    return valid;
  }

  submitPPCount() {
    this.dateFormSubmitted = true;
    if (this.checkDateError()) {
      this.getPPcounts(this.ppFromDate, this.ppToDate);
    }
  }

  getTripValue(key) {
    if (this.routeInfoData && this.routeInfoData[key]) return this.routeInfoData[key]
    else return 0
  }
  manageRoute() {
    this.router.navigate(['/organization/transport-manager/rostering/manage-route']);
  }

  patchSummaryData(data) {
    console.log(data);
    this.showChart = false;
    this.armpiedata = {
      "pickUpPointCount": {
        "regular": {
          "pickup": [
            {
              labels: "Completed",
              data: data?.pickUpPointCount?.route?.regular?.Pickup?.completed ?? 0,
              colors: "#4CAF50"
            },
            {
              labels: "Pending",
              data: data?.pickUpPointCount?.route?.regular?.Pickup?.pending ?? 0,
              colors: "#FF5252"

            },
            {
              labels: "Intransit",
              data: data?.pickUpPointCount?.route?.regular?.Pickup?.intransit ?? 0,
              colors: "#03A9F4"
            }
          ],
          "drop": [
            {
              labels: "Completed",
              data: data?.pickUpPointCount?.route?.regular?.Drop?.completed ?? 0,
            },
            {
              labels: "Pending",
              data: data?.pickUpPointCount?.route?.regular?.Drop?.pending ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.pickUpPointCount?.route?.regular?.Drop?.intransit ?? 0
            }
          ],
        },
        "occasional": {

          "pickup": [
            {
              labels: "Completed",
              data: data?.pickUpPointCount?.route?.occasional?.Pickup?.completed ?? 0,
            },
            {
              labels: "Pending",
              data: data?.pickUpPointCount?.route?.occasional?.Pickup?.pending ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.pickUpPointCount?.route?.occasional?.Pickup?.intransit ?? 0,
            },           
          ],
          "drop": [
            {
              labels: "Completed",
              data: data?.pickUpPointCount?.route?.occasional?.Drop?.completed ?? 0,
            },
            {
              labels: "Pending",
              data: data?.pickUpPointCount?.route?.occasional?.Drop?.pending ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.pickUpPointCount?.route?.occasional?.Drop?.intransit ?? 0,
            },          
          ],

        },
        "openBooking": {

          "pickup": [
            {
              labels: "Completed",
              data: data?.pickUpPointCount?.route?.openBooking?.Pickup?.completed ?? 0,
            },
            {
              labels: "Pending",
              data: data?.pickUpPointCount?.route?.openBooking?.Pickup?.pending ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.pickUpPointCount?.route?.openBooking?.Pickup?.intransit ?? 0,
            }
          ],
          "drop": [
            {
              labels: "Completed",
              data: data?.pickUpPointCount?.route?.openBooking?.Drop?.completed ?? 0,
            },
            {
              labels: "Pending",
              data: data?.pickUpPointCount?.route?.openBooking?.Drop?.pending ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.pickUpPointCount?.route?.openBooking?.Drop?.intransit ?? 0,
            }
          ],
        }
      },
      // pickup count end

      // tripcount start
      "tripCount": {
        "regular": {
          "pickup": [
            {
              labels: "Completed",
              data: data?.tripCount?.regular?.Pickup?.completed ?? 0,
            },
            {
              labels: "yetToStart",
              data: data?.tripCount?.regular?.Pickup?.yetToStart ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.tripCount?.regular?.Pickup?.intransit ?? 0,
            },

          ],
          "drop": [
            {
              labels: "Completed",
              data: data?.tripCount?.regular?.Drop?.completed ?? 0,
            },
            {
              labels: "yetToStart",
              data: data?.tripCount?.regular?.Drop?.yetToStart ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.tripCount?.regular?.Drop?.intransit ?? 0,
            },
          ],
        },
        "occasional": {
          "pickup": [
            {
              labels: "Completed",
              data: data?.tripCount?.occasional?.Pickup?.completed ?? 0,
            },
            {
              labels: "yetToStart",
              data: data?.tripCount?.occasional?.Pickup?.yetToStart ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.tripCount?.occasional?.Pickup?.intransit ?? 0,
            },
          ],
          "drop": [
            {
              labels: "Completed",
              data: data?.tripCount?.occasional?.Drop?.completed ?? 0,
            },
            {
              labels: "yetToStart",
              data: data?.tripCount?.occasional?.Drop?.yetToStart ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.tripCount?.occasional?.Drop?.intransit ?? 0,
            },
          ],
        },
        "openBooking": {
          "pickup": [
            {
              labels: "Completed",
              data: data?.tripCount?.openBooking?.Pickup?.completed ?? 0,
            },
            {
              labels: "yetToStart",
              data: data?.tripCount?.openBooking?.Pickup?.yetToStart ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.tripCount?.openBooking?.Pickup?.intransit ?? 0,
            },
          ],
          "drop": [
            {
              labels: "Completed",
              data: data?.tripCount?.openBooking?.Drop?.completed ?? 0,
            },
            {
              labels: "yetToStart",
              data: data?.tripCount?.openBooking?.Drop?.yetToStart ?? 0,
            },
            {
              labels: "Intransit",
              data: data?.tripCount?.openBooking?.Drop?.intransit ?? 0,
            },
          ],
        }

      },
      // trip count end
    }
    this.data = {
      "pickUpPointCount": {
        "regular": {
          "pickup": {
            "total": data?.pickUpPointCount?.route?.regular?.Pickup?.total ?? 0,
            "completed": data?.pickUpPointCount?.route?.regular?.Pickup?.completed ?? 0,
            "pending": data?.pickUpPointCount?.route?.regular?.Pickup?.pending ?? 0,
            "intransit": data?.pickUpPointCount?.route?.regular?.Pickup?.intransit ?? 0,
          },
          "drop": {
            "total": data?.pickUpPointCount?.route?.regular?.Drop?.total ?? 0,
            "completed": data?.pickUpPointCount?.route?.regular?.Drop?.completed ?? 0,
            "pending": data?.pickUpPointCount?.route?.regular?.Drop?.pending ?? 0,
            "intransit": data?.pickUpPointCount?.route?.regular?.Drop?.intransit ?? 0,
          }
        },
        "openBooking": {
          "drop": {
            "total": data?.pickUpPointCount?.route?.openBooking?.Pickup?.total ?? 0,
            "completed": data?.pickUpPointCount?.route?.openBooking?.Pickup?.completed ?? 0,
            "pending": data?.pickUpPointCount?.route?.openBooking?.Pickup?.pending ?? 0,
            "intransit": data?.pickUpPointCount?.route?.openBooking?.Pickup?.intransit ?? 0,
          },
          "pickup": {
            "total": data?.pickUpPointCount?.route?.openBooking?.Drop?.total ?? 0,
            "completed": data?.pickUpPointCount?.route?.openBooking?.Drop?.completed ?? 0,
            "pending": data?.pickUpPointCount?.route?.openBooking?.Drop?.pending ?? 0,
            "intransit": data?.pickUpPointCount?.route?.openBooking?.Drop?.intransit ?? 0,
          },
        },
        "occasional": {
          "pickup": {
            "total": data?.pickUpPointCount?.route?.occasional?.Pickup?.total ?? 0,
            "completed": data?.pickUpPointCount?.route?.occasional?.Pickup?.completed ?? 0,
            "pending": data?.pickUpPointCount?.route?.occasional?.Pickup?.pending ?? 0,
            "intransit": data?.pickUpPointCount?.route?.occasional?.Pickup?.intransit ?? 0,
          },
          "drop": {
            "total": data?.pickUpPointCount?.route?.occasional?.Drop?.total ?? 0,
            "completed": data?.pickUpPointCount?.route?.occasional?.Drop?.completed ?? 0,
            "pending": data?.pickUpPointCount?.route?.occasional?.Drop?.pending ?? 0,
            "intransit": data?.pickUpPointCount?.route?.occasional?.Drop?.intransit ?? 0,
          }
        }
      },
      "tripCount": {
        "regular": {
          "pickup": {
            "total": data?.tripCount?.route?.regular?.Pickup?.total ?? 0,
            "completed": data?.tripCount?.route?.regular?.Pickup?.completed ?? 0,
            "pending": data?.tripCount?.route?.regular?.Pickup?.pending ?? 0,
            "intransit": data?.tripCount?.route?.regular?.Pickup?.intransit ?? 0,
          },
          "drop": {
            "total": data?.tripCount?.route?.regular?.Drop?.total ?? 0,
            "completed": data?.tripCount?.route?.regular?.Drop?.completed ?? 0,
            "pending": data?.tripCount?.route?.regular?.Drop?.pending ?? 0,
            "intransit": data?.tripCount?.route?.regular?.Drop?.intransit ?? 0,
          }
        },
        "openBooking": {
          "drop": {
            "total": data?.tripCount?.route?.openBooking?.Pickup?.total ?? 0,
            "completed": data?.tripCount?.route?.openBooking?.Pickup?.completed ?? 0,
            "pending": data?.tripCount?.route?.openBooking?.Pickup?.pending ?? 0,
            "intransit": data?.tripCount?.route?.openBooking?.Pickup?.intransit ?? 0,
          },
          "pickup": {
            "total": data?.tripCount?.route?.openBooking?.Drop?.total ?? 0,
            "completed": data?.tripCount?.route?.openBooking?.Drop?.completed ?? 0,
            "pending": data?.tripCount?.route?.openBooking?.Drop?.pending ?? 0,
            "intransit": data?.tripCount?.route?.openBooking?.Drop?.intransit ?? 0,
          },
        },
        "occasional": {
          "pickup": {
            "total": data?.tripCount?.route?.occasional?.Pickup?.total ?? 0,
            "completed": data?.tripCount?.route?.occasional?.Pickup?.completed ?? 0,
            "pending": data?.tripCount?.route?.occasional?.Pickup?.pending ?? 0,
            "intransit": data?.tripCount?.route?.occasional?.Pickup?.intransit ?? 0,
          },
          "drop": {
            "total": data?.tripCount?.route?.occasional?.Drop?.total ?? 0,
            "completed": data?.tripCount?.route?.occasional?.Drop?.completed ?? 0,
            "pending": data?.tripCount?.route?.occasional?.Drop?.pending ?? 0,
            "intransit": data?.tripCount?.route?.occasional?.Drop?.intransit ?? 0,
          }
        }
      }
    }
    this.loadChartData(this.data,this.armpiedata);
  }

  loadChartData(data,chartData) {

    console.log(data)

    // count total chart data


    this.showChart = false;
    this.chart_pickUpPointCountregularPickuppie = {
      labels: ["total"],
      data: [
        data.pickUpPointCount.regular.pickup.total,

      ],
      title: '# Regular Pickup'
    }
    this.chart_pickUpPointCountregularDroppie = {
      labels: ["total"], data: [
        data.pickUpPointCount.regular.drop.total,]

    }

    this.chart_pickUpPointCountoccasionalPickuppie = {
      labels: ["total"], data: [
        data.pickUpPointCount.occasional.pickup.total,]

    }
    this.chart_pickUpPointCountoccasionalDroppie = {
      labels: ["total"], data: [
        data.pickUpPointCount.occasional.drop.total,]

    }

    this.chart_pickUpPointCountopenBookingPickuppie= {
      labels: ["total"], data: [
        data.pickUpPointCount.openBooking.pickup.total,]
  
    }
    this.chart_pickUpPointCountopenBookingDroppie= {
      labels: ["total"], data: [
        data.pickUpPointCount.openBooking.drop.total,]
  
    }

    this.chart_tripCountregularPickuptotal = {
      labels: ["total"], data: [
        data.tripCount.regular.pickup.total,]

    }
    this.chart_tripCountregularDroptotal = {
      labels: ["total"], data: [
        data.tripCount.regular.drop.total,]

    }
    this.chart_tripCountoccasionalPickuptotal = {
      labels: ["total"], data: [
        data.tripCount.occasional.pickup.total,]

    }

    this.chart_tripCountoccasionalDroptotal = {
      labels: ["total"], data: [
        data.tripCount.occasional.drop.total,]

    }

    this.chart_tripCountopenBookingPickuptotal= {
      labels: ["total"], data: [
        data.tripCount.openBooking.pickup.total,]
  
    }
  
    this.chart_tripCountopenBookingDroptotal= {
      labels: ["total"], data: [
        data.tripCount.openBooking.drop.total,]
  
    }

    // armpiechart data pickup point count
    this.chart_pickUpPointCountregularPickup = chartData.pickUpPointCount.regular.pickup;

    this.chart_pickUpPointCountregularDrop = chartData.pickUpPointCount.regular.drop;

    this.chart_pickUpPointCountoccasionalPickup = chartData.pickUpPointCount.occasional.pickup;

    this.chart_pickUpPointCountoccasionalDrop = chartData.pickUpPointCount.occasional.drop;

    this.chart_pickUpPointCountopenBookingPickup = chartData.pickUpPointCount.openBooking.pickup;

    this.chart_pickUpPointCountopenBookingDrop = chartData.pickUpPointCount.openBooking.drop;

    // trip count
    this.chart_tripCountregularPickup = chartData.tripCount.regular.pickup;
    this.chart_tripCountregularDrop = chartData.tripCount.regular.drop;
    this.chart_tripCountoccasionalPickup = chartData.tripCount.occasional.pickup;
    this.chart_tripCountoccasionalDrop = chartData.tripCount.occasional.drop;
    this.chart_tripCountopenBookingPickup = chartData.tripCount.openBooking.pickup;
    this.chart_tripCountopenBookingDrop = chartData.tripCount.openBooking.drop;

    this.showChart = true;
  }



  /* getTripChartLabel(type){
    let returnValue=[];
    if (type == 'assigned')
      returnValue[0] = this.assignedTrip+' / '+ this.totalTrip+' Trips';
    if (type == 'accepted')
      returnValue[0] = this.acceptedTrip+' / '+this.assignedTrip+' Trips';
    if (type == 'running')
      returnValue[0] = this.runningTrip+' / '+this.acceptedTrip+' Trips';
    console.log(returnValue);
    return returnValue;
  }

  getTripChartValue(type){
    let returnValue=[];
    let value;
    if (type == 'assigned') 
      value = ((this.assignedTrip / this.totalTrip) * 100).toFixed();
    if (type == 'accepted')  
      value = ((this.acceptedTrip / this.assignedTrip) * 100).toFixed();
    if (type == 'running') 
      value = ((this.runningTrip / this.acceptedTrip) * 100).toFixed();
    returnValue[0] = value;
    console.log(returnValue);
    return returnValue;
  }
 */


}

